<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="clearfix">
            <b-card>
              <b-row>
                <b-col cols="4" class="text-right">
                  <h1 class="display-3 mr-4">500</h1>
                </b-col>
                <b-col cols="8" class="text-left">
                  <h4 class="pt-3">Oops! Un Authorize Access.</h4>
                  <span class="text-muted">The page you are looking for is secured.</span><br>
                  <b-link @click="goback()">Go Back</b-link>

                </b-col>
              </b-row>
              
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
created: async function () {
},
methods:{
  goback(){
    router.push({name:this.$store.state.prevRoute.name})
  }
}
  };
</script>
